exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.globalMenuGroup-panel {\n  min-width: 300px;\n}\n.global-menu-group-panel {\n  height: 50vh;\n  overflow: scroll;\n  border: solid 1px #757575;\n  margin-right: 5px;\n  margin-top: 10px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n", ""]);

